export type AuthSession = {
  accessToken: string;
  refreshToken: string;
};

export function setSessionInLocalStorage(session: AuthSession) {
  localStorage.setItem('session', JSON.stringify(session));
}

export function removeSessionInLocalStorage() {
  localStorage.removeItem('session');
}

export function getSessionFromLocalStorage(): AuthSession | null {
  const item = localStorage.getItem('session');
  if (item == null) return null;
  return JSON.parse(item);
}
